import React, { type FC } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import svgRectangleWhite from '../assets/rectangle_white.svg'
import svgRectangleOrange from '../assets/rectangle_orange.svg'
import svgCross from '../assets/cross.svg'
import svgCheck from '../assets/check.svg'

interface IProps {
  index: number
  lastIndex: number
  status: boolean | undefined
  goToQuestion: (index: number) => void
}

const BreadcrumbAnswerStatus: FC<IProps> = ({ index, lastIndex, status, goToQuestion }) => {
  return (
    <div className='flex-1'>
      {status === undefined ? (
        <AnimatePresence mode='wait'>
          {lastIndex === index ? (
            <motion.div
              key={'question' + index}
              className='flex items-center gap-2 cursor-pointer'
              {...(lastIndex !== 0 && { initial: { opacity: 0 }, animate: { opacity: 1, transition: { delay: 0.25 } } })}
              exit={{ opacity: 0 }}
              onClick={() => {
                goToQuestion(index)
              }}
            >
              <div className='shrink-0 bg-white h-[2.5rem] w-[2.5rem] rounded-full text-duskBlack grid place-items-center'>{lastIndex + 1}</div>
              <div className='w-full border-t border-dashed'></div>
            </motion.div>
          ) : (
            <motion.div
              key={'undefined' + index}
              className='flex items-center gap-2 h-[2.5rem]'
              {...(lastIndex !== 0 && { initial: { opacity: 0 }, animate: { opacity: 1, transition: { delay: 0.25 } } })}
              exit={{ opacity: 0 }}
            >
              <img
                className='shrink-0 h-[0.75rem] w-[0.75rem]'
                src={svgRectangleWhite}
              />
              <div className='w-full border-t border-dashed'></div>
            </motion.div>
          )}
        </AnimatePresence>
      ) : (
        <AnimatePresence mode='wait'>
          {status ? (
            <motion.div
              key={'check' + index}
              className='flex items-center gap-2 h-[2.5rem] cursor-pointer'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: 0.25 } }}
              onClick={() => {
                goToQuestion(index)
              }}
            >
              <div className='shrink-0 relative h-[2.5rem] w-[2.5rem]'>
                <img
                  className='h-full w-full'
                  src={svgRectangleOrange}
                />
                <img
                  className='h-[0.5rem] w-[0.5rem] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
                  src={svgCheck}
                />
              </div>
              <motion.div
                className='w-full border-t border-sunriseGold'
                initial={{ width: 0 }}
                animate={{ width: '100%', transition: { delay: 0.25 } }}
              ></motion.div>
            </motion.div>
          ) : (
            <motion.div
              key={'cross' + index}
              className='flex items-center gap-2 h-[2.5rem] cursor-pointer'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: 0.25 } }}
              onClick={() => {
                goToQuestion(index)
              }}
            >
              <div className='shrink-0 relative h-[2.5rem] w-[2.5rem]'>
                <img
                  className='h-full w-full'
                  src={svgRectangleOrange}
                />
                <img
                  className='h-[0.5rem] w-[0.5rem] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
                  src={svgCross}
                />
              </div>
              <motion.div
                className='w-full border-t border-sunriseGold'
                initial={{ width: 0 }}
                animate={{ width: '100%', transition: { delay: 0.25 } }}
              ></motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  )
}

export default BreadcrumbAnswerStatus
